import { analyticsDashboard as TYPES } from './../action_types';
import * as Ajax from './services';
import { dateParams as dateParamsUtil } from './utilities';

const fetch = function () {
  return function (dispatch, getState) {
    if (getState().AnalyticsDashboard.PreviousDateRangeHits.meta.exhausted)
      return;
    if (getState().AnalyticsDashboard.PreviousDateRangeHits.meta.fetching)
      return;

    dispatch({
      type: TYPES.FETCH_OLD_HITS_REQUEST,
    });

    const displayedDates = getState().AnalyticsDashboard.DisplayedDates;
    const dateParams = dateParamsUtil({
      start: moment(displayedDates.start)
        .subtract(displayedDates.dayCount, 'days')
        .toDate(),
      finish: moment(displayedDates.finish)
        .subtract(displayedDates.dayCount, 'days')
        .toDate(),
    });

    Ajax.HitsService(dateParams)
      .done(function (hitsResponse) {
        dispatch({
          type: TYPES.FETCH_OLD_HITS_SUCCESS,
          hits: hitsResponse.hits,
        });
      })
      .fail(function () {
        dispatch({
          type: TYPES.FETCH_OLD_HITS_FAILURE,
        });
      });
  };
};

const PreviousDateRangeHits = {
  fetch: fetch,
};
export { PreviousDateRangeHits };

const initialState = {
  models: [],
  meta: {
    exhausted: false,
    fetching: false,
    errorFetching: false,
  },
};

const reducer = function (state = initialState, action) {
  switch (action.type) {
    case TYPES.FETCH_OLD_HITS_REQUEST:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: true,
        }),
      });

    case TYPES.FETCH_OLD_HITS_SUCCESS:
      return Object.assign({}, state, {
        models: state.models.concat(action.hits),
        meta: Object.assign({}, state.meta, {
          fetching: false,
          exhausted: true,
          errorFetching: false,
        }),
      });

    case TYPES.FETCH_OLD_HITS_FAILURE:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: false,
          errorFetching: true,
        }),
      });

    case TYPES.SET_DISPLAYED_DATES:
      return initialState;

    default:
      return state;
  }
};

export { reducer, reducer as default };
